export const getBase64AsFile = async (image: string) => {
	// @ts-ignore
	const response = await fetch(image);
	const blob = await response.blob();
	// @ts-ignore
	return new File([blob], 'file.png', { type: blob.type });
};
